import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Radio, Row, Col } from 'antd'
import { injectIntl } from 'react-intl'
import { requireAuthentication } from '../helpers/authentication'
import MustHave from '../containers/MustHave'
import Forbidden from '../components/Forbidden'
import IncidentMgmtPage from './IncidentMgmt'
import { IncidentList } from './IncidentList'
import './styles.scss'

const IncidentTabs = ({ intl }) => {
  const history = useHistory()
  const location = useLocation()
  // The active tab is tracked in the URL (rather than plain useState) so that
  // navigating away (e.g. to edit a repair note) and coming back via
  // history.goBack() restores whichever tab the user was actually on --
  // otherwise this component remounts and silently falls back to the default.
  const tab =
    new URLSearchParams(location.search).get('tab') === 'incident-management'
      ? 'incident-management'
      : 'incident-list'

  const setTab = (value) => {
    const params = new URLSearchParams(location.search)
    params.set('tab', value)
    // replace, not push -- switching tabs shouldn't add its own back-button
    // stop separate from just leaving this page.
    history.replace(`/incidents?${params.toString()}`)
  }

  return (
    <MustHave permission="page-incidents:get" fallback={<Forbidden />}>
      <div id="incident-tabs-container">
        <Row style={{ margin: '24px' }}>
          <Col span={8} />
          <Col span={8}>
            <Radio.Group
              options={[
                {
                  label: intl.formatMessage({
                    id: 'incidentMgmt.incidentTabs.incidentList',
                    defaultMessage: 'Incident List',
                  }),
                  value: 'incident-list',
                },
                {
                  label: intl.formatMessage({
                    id: 'incidentMgmt.incidentTabs.incidentManagement',
                    defaultMessage: 'Incident Management',
                  }),
                  value: 'incident-management',
                },
              ]}
              onChange={(e) => setTab(e.target.value)}
              value={tab}
              optionType="button"
              block
              buttonStyle="solid"
              style={{ marginBottom: '16px' }}
            />
          </Col>
          <Col span={8} />
        </Row>
        <Row className="incident-tabs-content-row">
          <Col span={24} id="incident-tabs-page-container">
            {tab === 'incident-list' ? <IncidentList /> : <IncidentMgmtPage />}
          </Col>
        </Row>
      </div>
    </MustHave>
  )
}

export default requireAuthentication(injectIntl(IncidentTabs))
